import React from "react";

import styled from "styled-components/macro";

import { DashboardIllustration } from "img/dashboardIllustration";

const IllustrationContainer = styled.div`
  height: 150px;
  width: 150px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  margin: auto;
  display: flex;
  align-items: center;
`;

export const EmptyDashboardIllustration = () => {
  return (
    <IllustrationContainer>
      <DashboardIllustration />
    </IllustrationContainer>
  );
};
